import React from 'react';

import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import { useLocation } from 'react-router-dom';

import { useAddCurrentFavoritePage } from '@src/hooks/favoritePages';

const FavoritesMenuAdd = ({ onAdd }) => {
    const { pathname } = useLocation();
    const [createFavoritePage] = useAddCurrentFavoritePage({
        onSuccess: () => onAdd && onAdd(),
    });

    if (!pathname || pathname === '/' || pathname === '/favorites') {
        return null;
    }

    return (
        <Dropdown.Item className="add-favorite-page" onSelect={createFavoritePage}>
            Add to Favorites
        </Dropdown.Item>
    );
};

FavoritesMenuAdd.propTypes = {
    onAdd: PropTypes.func,
};

export default React.memo(FavoritesMenuAdd);
